// DEPRECATED: Use CompactRoomModal instead
import { CompactRoomModal } from './CompactRoomModal';

interface CreateRoomModalProps {
  onClose: () => void;
  projectId?: string;
  siteId?: string;
  title?: string;
}

export const CreateRoomModal = ({ onClose, projectId, siteId, title = "Create New Room" }: CreateRoomModalProps) => {
  // Use the new CompactRoomModal component
  return (
    <CompactRoomModal
      onClose={onClose}
      projectId={projectId}
      siteId={siteId}
      title={title}
    />
  );
};